import { requestJson } from "./stratoClient";

export function lookupStatus({ publicCode, email }) {
  return requestJson("/public/v1/quotes/status", {
    method: "POST",
    body: {
      publicCode: String(publicCode || "").trim(),
      email: String(email || "").trim().toLowerCase(),
    },
  });
}

export function toStatusViewRecord(request) {
  if (!request) return null;

  return {
    reference: request.reference || request.publicCode,
    publicCode: request.publicCode || request.reference,
    status: request.status,
    publicStage: request.publicStage,
    currentIndex: Number.isInteger(request.currentIndex) ? request.currentIndex : 0,
    project: request.project,
    material: request.material,
    color: request.color,
    finish: request.finish,
    quantity: request.quantity,
    type: request.type,
    requestDate: formatDate(request.requestDate),
    lastUpdate: formatDate(request.lastUpdate),
    file: request.file || null,
    fulfillment: toFulfillmentViewRecord(request.fulfillment),
  };
}

function toFulfillmentViewRecord(fulfillment) {
  if (!fulfillment) return null;
  return {
    status: fulfillment.status || "",
    label: fulfillment.label || "",
    carrier: fulfillment.carrier || "",
    trackingNumber: fulfillment.trackingNumber || "",
    trackingUrl: fulfillment.trackingUrl || "",
    customerNote: fulfillment.customerNote || "",
    shippedAt: formatDate(fulfillment.shippedAt),
    deliveredAt: formatDate(fulfillment.deliveredAt),
    updatedAt: formatDate(fulfillment.updatedAt),
  };
}

function formatDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}
